// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8353) return "static/chunks/8353-c1c60c7dd4e015e7.js";
	if (chunkId === 6884) return "static/chunks/6884-8f3daa10b37fc6ac.js";
	if (chunkId === 3652) return "static/chunks/3652-7f93fff15db7efe2.js";
	if (chunkId === 4959) return "static/chunks/4959-4f7f7f9fc449e0fc.js";
	if (chunkId === 5464) return "static/chunks/5464-60857583177d51e8.js";
	if (chunkId === 8899) return "static/chunks/8899-20de6048cbeb5307.js";
	if (chunkId === 7208) return "static/chunks/7208-861a8c7a15b76e17.js";
	if (chunkId === 6014) return "static/chunks/6014-2135df5adc34c63d.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4850 ? "52774a7f" : chunkId) + "." + {"444":"e5041685bbb18655","1471":"fa4866e93c8c7e17","3736":"74c52d75203074de","4628":"325587f4f888ee4f","4850":"d193dad895e14500","5466":"8dcabcdfc07e5ade","6053":"7d09d75e0c7e433b","9047":"d457965e5bc4270d"}[chunkId] + ".js";
};